// To parse this data:
//
//   import { Convert } from "./file";
//
//   const dossier = Convert.toDossier(json);
//
// These functions will throw an error if the JSON doesn't
// match the expected class, even if the JSON is valid

export class Dossier {
    _id : String;
    general:    General;
    __v:        number;
    fe:         Fe;
    collaborateur: Collaborateur[];
    dernierContrat: DernierContrat;
    dcs:        Dc[];
    langues:    Langue[];
    diplomes:   Diplome[];
    adresse:   Adresse;
    cvFile : String[];
    files : String[];
    bilansAnnuels: BilanAnnuel[];
    favorites: Favorite[]; //Stocker les identifiant des utilisateurs ayant ajouter un dossier en favorite
    missions: Mission[];
}

//Mettre l'ajout des dossiers en favoris
export class Publish{
    publishEmail: boolean;
    publishNumber: boolean;
} 
//Mettre l'ajout des dossiers en favoris
export class Favorite{
    idManager: String;
    manager: String;
}

export class Adresse {
    rue:        string;
    ville:      string;
    cp:         number;
    pays: string;
    feetGroundInParis: string;
}

export class Collaborateur {
    natureContrat : string;
    responsable: string;
    fonction: string;
    df:          Date;
    dd:          Date;
    constructor (){
      this.dd = new Date();
    }
}

//Stocker les informations du dernier contrat du tableau des contrats (collaborateur)
export class DernierContrat {
    natureContrat : string;
    responsable: string;
    fonction: string;
    df:          Date;
    dd:          Date;
}

/*export class Mission {
    debut:       string;
    fin:         string;
    client:      string;
    description: string;
}*/

export class Dc {
    _id : string;
    resume : String;
    titre : String;
    manager:    string;
    date:       string;
    certifs:    Certif[];
    experience : Experience[];
    skills:     Skill[];
    diplomesDC:   Diplome[];
}

export class Certif {
    titre: string;
    date:  Number;
}

export class Realisation{
    realisation : string;
}

export class Experience {
    actuelle: boolean;
    company:  string;
    position: string;
    to:      Date;
    from:     Date;
    description : string;
    realisations : string;
    envTech : string;
}


export class Skill {
    domaine: String;
    dskills: String;
}

export class Diplome {
    diplome : string;
    ecole: string;
    annee: number;
}


export class Fe {
    positionnement: string;
    noteGeneral: number; // Note géneral pour toutes les évaluations
    reference:      string;
    refPrise: boolean;
    provenance:     string;
    coptationIsValided : boolean;
    details:        string;
    experience:     number;
    actions:        Actions;
    remarques:      Remarques;
    connaissances:  Connaissances;
    adm:            Adm;
}


export class Actions {
    action:       string;
    evals:        Eval[];
    validation:   boolean;
    publishEmail: boolean; // afficher ou masquer l'email dans l'annuaire
    publishNumber: boolean;// afficher ou masquer le numéro dans l'annuaire
    raison:       string;
}

export class Eval {
    manager: string;
    date:    Date;
    motivation:   string;
    dynamisme:    string;
    nivTech:      string;
    presentation: string;
    moyenne: number;//Moyenne obtenue lors d'un présentation
    constructor (){
      this.date = new Date();
    }
}

export class Adm {
    dispo:       string;
    raisonDepart:  string;
    typeContrat: string;
    remunMin:  number;
    remunActuelle: number;
    employeur:   string;
}

export class Connaissances {
    souhait: string;
    fonc:    string;
    tech:    string;
    anglais:    string; // type select

}

export class Remarques {
    dc:         string;
    retard:     string;
    prendNotes: string;
    visiteWeb:  string;
    remarque:   string;
    remarque2: string;
    piste:      string;
    raisonRetard : string;

}

export class General {
    public profil : string;
    public permis:         string;
    public fonctionWellD : string; //La superbe fonction que occupe le collaborateur ou Ancien collaborateur
    public statutMarital: string;
    public refPrise: boolean;
    public validiteSejour: string;
    public titreSejour:    string;
    public nationnalite:   string;
    public dateNaissance:  string;
    public telephone:      string;
    public prenom:         string;
    public email:          string;
    public nom:            string;
    public cvBrut:         string;
    public cvBrut2:        string;
    public vehicule:       string;
    public typePermis:     string;
    public lieuNaissance:  string;
    public mobilite:       string;
    public dateDernierEntretien: Date;
}

export class Langue {
    langue: string;
    niveau: string;
}


//Faire le bilan annuel pour un collaborateur
export class Projet {
    nbreMois : number;
    posteOccupe : string;
    objectifAtteint : number;
    integrationEtSavoir : number;
    rapiditeAcquisition : number;
    priseInitiative : number;
    communicationEtLibrable : number;
    moyenneMission : number; //Moyenne pour une mission

}
export class VieInterne {
    ponctualite : number;
    respectRegle : boolean;
    plantage : boolean;
    participationEven : boolean;
    OrganisationEven : boolean;
    moyenneVieInterne : number; //Moyenne de la vie interne
}
export class Developpement{
    proposition : number;
    animFormation: Boolean;
}

export class PerspecEtSouhait {
    dateDebut  : Date;
    detail : string;
}


export class BilanAnnuel {
    annee : number;
    collaborateur: string;
    dateEntreeCdiWelld : Date;
    nombreAnneeExp : number;
    fonctionActuelle: string;
    occupeDepuis : Date;
    dateEntretien : Date;
    responsableActuelle: string;
    fileBA : String[];
    projets: Projet[];
    vieInterne : VieInterne;
    developpement : Developpement;
    moyenneVieInterneEtdevelop : number; // Moyenne vie interne et développement
    moyenneMissions : number; //Moyenne des missions
    moyenneTotalBA : number;  // Moyenne total du bilan annuel
    perspecEtSouhaits : PerspecEtSouhait[];
    reactiviteManger : string;
    ecouteManger : string;
    honneteteManger : string;
    dynamismeManger : string;
    sympathieManger : string;
    ideePourWelld : string;
    commentAmeliorervViePerso : string;
    observaPlanActionDecison : string;
    informations : string;
    tovalidBA : boolean;  // Pour valider un bilan annuel par le manager
    isValidBA : boolean;  // Faire valider par le collaboratuer.
}








//Ajouter un ordre de mission pour un candidat
export class Mission{
    idMission : number;
    poste: string; 
    client : string;
    adresse : string;
    interlocuteurClient : string;
    debutMission: Date;
    finMission : Date;
    descriptionProjet: string;
    deplacement: string;
    restauration: string;
    dateValidation: string;
    autres: string;
    isValidated: boolean;  //valider l'odre de mission par le Collaborateur
    toValidate : boolean ; //Donner la possibilité au Collaborateur de valider la mission
    constructor (){
        this.debutMission = new Date();
      }

}





// Converts JSON strings to/from your types
// and asserts the results of JSON.parse at runtime
export namespace Convert {
    export function toDossier(json: string): Dossier[] {
        return cast(JSON.parse(json), a(r("Dossier")));
    }

    export function dossierToJson(value: Dossier[]): string {
        return JSON.stringify(value, null, 2);
    }

    function cast<T>(obj: any, typ: any): T {
        if (!isValid(typ, obj)) {
            throw Error(`Invalid value`);
        }
        return obj;
    }

    function isValid(typ: any, val: any): boolean {
        if (typ === "any") { return true; }
        if (typ === null) { return val === null; }
        if (typ === false) { return false; }
        while (typeof typ === "object" && typ.ref !== undefined) {
            typ = typeMap[typ.ref];
        }
        if (Array.isArray(typ)) { return isValidEnum(typ, val); }
        if (typeof typ === "object") {
            return typ.hasOwnProperty("unionMembers") ? isValidUnion(typ.unionMembers, val)
                : typ.hasOwnProperty("arrayItems")    ? isValidArray(typ.arrayItems, val)
                : typ.hasOwnProperty("props")         ? isValidObject(typ.props, typ.additional, val)
                : false;
        }
        return isValidPrimitive(typ, val);
    }

    function isValidPrimitive(typ: string, val: any) {
        return typeof typ === typeof val;
    }

    function isValidUnion(typs: any[], val: any): boolean {
        // val must validate against one typ in typs
        return typs.some((typ) => isValid(typ, val));
    }

    function isValidEnum(cases: string[], val: any): boolean {
        return cases.indexOf(val) !== -1;
    }

    function isValidArray(typ: any, val: any): boolean {
        // val must be an array with no invalid elements
        return Array.isArray(val) && val.every((element) => {
            return isValid(typ, element);
        });
    }

    function isValidObject(props: { [k: string]: any }, additional: any, val: any): boolean {
        if (val === null || typeof val !== "object" || Array.isArray(val)) {
            return false;
        }
        return Object.getOwnPropertyNames(val).every((key) => {
            const prop = val[key];
            if (Object.prototype.hasOwnProperty.call(props, key)) {
                return isValid(props[key], prop);
            }
            return isValid(additional, prop);
        });
    }

    function a(typ: any) {
        return { arrayItems: typ };
    }

    function u(...typs: any[]) {
        return { unionMembers: typs };
    }

    function o(props: { [k: string]: any }, additional: any) {
        return { props, additional };
    }

    function m(additional: any) {
        return { props: {}, additional };
    }

    function r(name: string) {
        return { ref: name };
    }

    const typeMap: any = {
        "Dossier": o({
            general: r("General"),
            __v: 0,
            fe: r("Fe"),
            collaborateur: a(r("Collaborateur")),
            dcs: a(r("Dc")),
            langues: a(r("Langue")),
            diplomes: a(r("Diplome")),
            adresses: a(r("Adress")),
            bilansAnnuels: a(r("BilanAnnuel")),
            favorites: a(r("Favorite")),
            missions: a(r("mission")),
            dateDernierEntretien : '',
        }, false),
        "Adress": o({
            rue: "",
            ville: "",
            cp: 0,
            pays: "",
            feetGroundInParis: "", 
        }, false),
        "Collaborateur": o({
            natureContrat: "",
            responsable: "",
            df: "",
            dd: "",
            fonction: "",
            missions: a(r("Mission")),
        }, false),
        "dernierContrat": o({
            natureContrat: "",
            responsable: "",
            df: "",
            dd: "",
            fonction: "",
        }, false),
        /*"Mission": o({
            debut: "",
            fin: "",
            client: "",
            description: "",
        }, false),*/
        "Dc": o({
            manager: "",
            date: "",
            certifs: a(r("Certif")),
            experience: a(r("Experience")),
            skills: a(r("Skill")),
        }, false),
        "Certif": o({
            titre: "",
            date: 0,
        }, false),
        "Experience": o({
            actuelle: true,
            company: "",
            position: "",
            to: u(undefined, ""),
            from: "",
        }, false),
        "Skill": o({
            domaine: "",
            dskills: a(r("Dskill")),
        }, false),
        "Dskill": o({
            skill: "",
        }, false),
        "Diplome": o({
            ecole: "",
            annee: 0,
        }, false),
        "Fe": o({
            positionnement: "",
            noteGeneral: 0, //Note génerale pour toutes les évaluations
            reference: "",
            provenance: "",
            details:  "",
            experience: 0,
            actions: r("Actions"),
            remarques: r("Remarques"),
            connaissances: r("Connaissances"),
            adm: r("Adm"),
        }, false),
        "Actions": o({
            motivation: "",
            dynamisme: "",
            nivTech: "",
            presentation: "",
            moyenne: 0,
            action: "",
            evals: a(r("Eval")),
            validation:  false,
            publishEmail: false,
            publishNumber: false,
            raison: "",
        }, false),

        "Eval": o({
            manager: "",
            date: "",
            motivation:   "",
            dynamisme:    "",
            nivTech:      "",
            presentation: "",
            moyenne: 0,
        }, false),
        "Adm": o({
            dispo: "",
            raisonDepart: "",
            typeContrat: 0,
            salSouhaite: 0,
            remunMin: 0,
            remunActuelle: 0,
            employeur: "",
        }, false),
        "Connaissances": o({
            souhait: "",
            fonc: "",
            tech: "", 
            anglais: "",

        }, false),
        "Remarques": o({
            dc: "",
            retard: "",
            prendNotes: "",
            visiteWeb: "",
            remarque: "",
            remarque2: "",
            piste:  "",
            raisonRetard : "",

        }, false),
        "General": o({
            permis: "",
            fonctionWellD: "",
            statutMarital: "",
            validiteSejour: "",
            titreSejour: "",
            nationnalite: "",
            dateNaissance: "",
            telephone: "",
            prenom: "",
            nom: "",
        }, false),
        "Langue": o({
            langue: "",
            niveau: "",
        }, false),
        "Favorite": o({
            idManger: "",
            manager: "",
        }, false),
        "Mission": o({
            idMission :0,
            poste: "",
            client: "",
            adresse: "",
            interlocuteurClient: "",
            debutMission: "",
            finMission : "",
            descriptionProjet: "",
            deplacement: "",
            restauration: "",
            dateValidation: "",
            autres : "",
            toValidate : false ,
            isValidated: false,
        }, false),
        "BilanAnnuel": o({
            annee : 0,
            collaborateur: "",
            dateEntreeCdiWelld: "",
            nombreAnneeExp : 0,
            fonctionActuelle :"",
            occupeDepuis: "",
            dateEntretien: "",
            responsableActuelle :"",
            reactiviteManger : "",
            ecouteManger : "",
            honneteteManger : "",
            dynamismeManger : "",
            sympathieManger : "",
            projets : a(r("Projet")),
            perspecEtSouhaits : a(r("PerspecEtSouhait")),
            vieInterne : r("VieInterne"),
            developpement: r("Developpement"),
            moyenneVieInterneEtdevelop : 0,
            moyenneMissions : 0,
            moyenneTotalBA : 0,
            ideePourWelld : "",
            commentAmeliorervViePerso :"",
            observaPlanActionDecison : "",
            informations: "",
            tovalidBA: false,
            isValidBA : false,
        }, false),

    };
}



// WEBPACK FOOTER //
// ./src/app/entities/dossier.ts